import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { fetchAllBidderBiddingInfoIfNeeded } from '@/redux/modules/bidder/biddingInfoAll/bidderBiddingInfoAll.actions';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';
import { getAuthToken, getUserData } from '@/redux/modules/account/user/user.selectors';
import { getDeployment } from '@/redux/modules/config';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import {
    getItemSummaryCatalogId,
    getItemSummaryIsTimedPlusAuction,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { postRetractBid, postRetractTimedPlusBid } from '@/redux/modules/retractBid/retractBid.api';
import { SubmitRetractBidParams, SubmitRetractBidPayload } from '@/redux/modules/retractBid/retractBid.types';
import { trackBidRetractedAnalytics } from '@/utils/amplitude/analytics';

export const submitRetractBid = createAsyncThunk<SubmitRetractBidPayload, SubmitRetractBidParams>(
    'la/ui/retractBid/submitRetractBid',
    async ({ itemId, location, retractionExplanation, retractionReason }, { dispatch, getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);

        const catalogId = getItemSummaryCatalogId(state, itemId);
        const isTimedPlus = getItemSummaryIsTimedPlusAuction(state, itemId);
        const { bidderId } = getUserData(state);

        if (isTimedPlus) {
            await postRetractTimedPlusBid({
                authToken,
                catalogId,
                deployment,
                itemId,
                retractionExplanation,
                retractionReason,
            });
        } else {
            await postRetractBid({
                authToken,
                bidderId,
                deployment,
                itemId,
                retractionExplanation,
                retractionReason,
            });
        }

        await dispatch(fetchAllBidderBiddingInfoIfNeeded(true));

        trackBidRetractedAnalytics({
            pageName: getAmplitudePageNameFromPath(location.pathname),
            url: getFullUrl(deployment, location.pathname),
        });

        return { itemId };
    }
);
